import fetchJSON from '../../fetchers/utils/fetchJSON.js';
import getFetchOptions from '../../fetchers/utils/getFetchOptions.js';
const options = {
  circuitBreaker: {
    id: 'vrsCircuitBreaker',
    timeout: 5000,
    resetTimeout: 300000,
    fallback: {
      error: 'Circuit Breaker for /vrs is open'
    }
  }
};
function VrsFetcher(path) {
  return {
    path: path + 'cars-for-sale/vrs',
    async fetch(endpoint) {
      let additonalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      try {
        const data = await fetchJSON(this.path + endpoint, getFetchOptions({
          ...additonalOptions,
          ...options
        }));
        return data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching VRS data: ', error);
      }
      return {};
    }
  };
}
export { VrsFetcher as default };
